import(/* webpackMode: "eager" */ "D:\\a\\1\\s\\shesha-functional-tests\\adminportal\\src\\app\\(main)\\dynamic\\[...path]\\page.tsx");
